import React from "react";
import { Divider, Flex, Popover, Typography } from "antd";

const PopoverContent = ({ description }) => (
  <Flex vertical style={{ maxWidth: 420, maxHeight: 280, overflowY: "auto" }}>
    {description
      .split("|")
      .map((s) => s.trim())
      .filter(Boolean)
      .map((para, idx) => (
        <Typography.Paragraph
          key={idx}
          style={{ fontSize: 13, lineHeight: 1.7, marginBottom: 8 }}
        >
          {para}
        </Typography.Paragraph>
      ))}
  </Flex>
);

// description originates in a schema-free API field (skill_description) that's
// usually a pipe-delimited string but sometimes arrives as an array of notes
// (e.g. contextual_variations) — normalize both, and drop anything else (a
// stray number/object) that would crash PopoverContent's .split.
const normalizeDescription = (description) => {
  if (typeof description === "string") return description;
  if (Array.isArray(description)) {
    return description.filter((s) => typeof s === "string").join(" | ");
  }
  return "";
};

const SkillNameCell = ({ title, description }) => {
  const normalizedDescription = normalizeDescription(description);

  return (
    <Flex vertical>
      <Typography.Text strong>{title}</Typography.Text>
      {normalizedDescription && (
        <Popover
          title={
            <Flex vertical gap={4}>
              <Typography.Text strong style={{ fontSize: 14 }}>
                {title}
              </Typography.Text>
              <Divider style={{ margin: 0 }} />
            </Flex>
          }
          content={<PopoverContent description={normalizedDescription} />}
          trigger="hover"
          placement="right"
        >
          <Typography.Paragraph
            type="secondary"
            style={{ fontSize: 12, marginBottom: 0 }}
            ellipsis={{ rows: 2 }}
          >
            {normalizedDescription}
          </Typography.Paragraph>
        </Popover>
      )}
    </Flex>
  );
};

export default SkillNameCell;
